









































































import Vue from 'vue'
import Button from '@/components/shared/atoms/Button/Button'
import Modal from '@/components/shared/atoms/Modal'
import TermMemberContainer from '@/containers/Terms/Member'
import TermServiceContainer from '@/containers/Terms/Service'
import { IProfileSeed, IProfileFields } from '@/entities/Profile'
import { range, oneOf } from '@/utils/helper'

interface IData {
  showTermModal: boolean
  showServiceModal: boolean
}

export default Vue.extend({
  components: {
    Button,
    Modal,
    TermMemberContainer,
    TermServiceContainer
  },
  props: {
    fields: {
      type: Object as () => IProfileSeed | IProfileFields,
      required: true
    },
    token: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: '登録内容確認｜新規会員登録'
    },
    mode: {
      type: String,
      default: 'create',
      validator: oneOf(['create', 'update'])
    }
  },
  data(): IData {
    return {
      showTermModal: false,
      showServiceModal: false
    }
  },
  computed: {
    maskedPassword(): string {
      if ('password' in this.fields)
        return range(1, this.fields.password.length)
          .map(_ => '*') // eslint-disable-line @typescript-eslint/no-unused-vars
          .join('')
      return ''
    },
    zipCode(): string {
      if ('zipcode' in this.fields) {
        const { zipcode } = this.fields
        if (!zipcode) return ''
        return `〒${zipcode.toString().slice(0, 3)}-${zipcode.toString().slice(3, zipcode.length)}`
      }
      return ''
    },
    sex(): string {
      if ('sex' in this.fields) {
        const { sex } = this.fields
        if (sex === 'f') return '女性'
        if (sex === 'm') return '男性'
      }
      return '未設定'
    },
    submitButtonText(): string {
      if (this.mode === 'create') {
        return '登録'
      } else if (this.mode === 'update') {
        return '変更'
      } else {
        return ''
      }
    }
  },
  methods: {
    submit() {
      this.$emit('success', this.fields)
    }
  }
})
